// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v3.21.12
// source: schema.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Struct } from "./google/protobuf/struct";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "schema";

export enum UserType {
  UNDEFINED = 0,
  REVIEWER = 1,
  PROVIDER = 2,
  ADMIN = 3,
  UNRECOGNIZED = -1,
}

export function userTypeFromJSON(object: any): UserType {
  switch (object) {
    case 0:
    case "UNDEFINED":
      return UserType.UNDEFINED;
    case 1:
    case "REVIEWER":
      return UserType.REVIEWER;
    case 2:
    case "PROVIDER":
      return UserType.PROVIDER;
    case 3:
    case "ADMIN":
      return UserType.ADMIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserType.UNRECOGNIZED;
  }
}

export function userTypeToJSON(object: UserType): string {
  switch (object) {
    case UserType.UNDEFINED:
      return "UNDEFINED";
    case UserType.REVIEWER:
      return "REVIEWER";
    case UserType.PROVIDER:
      return "PROVIDER";
    case UserType.ADMIN:
      return "ADMIN";
    case UserType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CaseStatus {
  INVALID_CASE_STATUS = 0,
  PROCESSING = 1,
  GENERATED = 2,
  UNCLAIMED = 3,
  IN_REVIEW = 4,
  RETURNED = 5,
  UNRECOGNIZED = -1,
}

export function caseStatusFromJSON(object: any): CaseStatus {
  switch (object) {
    case 0:
    case "INVALID_CASE_STATUS":
      return CaseStatus.INVALID_CASE_STATUS;
    case 1:
    case "PROCESSING":
      return CaseStatus.PROCESSING;
    case 2:
    case "GENERATED":
      return CaseStatus.GENERATED;
    case 3:
    case "UNCLAIMED":
      return CaseStatus.UNCLAIMED;
    case 4:
    case "IN_REVIEW":
      return CaseStatus.IN_REVIEW;
    case 5:
    case "RETURNED":
      return CaseStatus.RETURNED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CaseStatus.UNRECOGNIZED;
  }
}

export function caseStatusToJSON(object: CaseStatus): string {
  switch (object) {
    case CaseStatus.INVALID_CASE_STATUS:
      return "INVALID_CASE_STATUS";
    case CaseStatus.PROCESSING:
      return "PROCESSING";
    case CaseStatus.GENERATED:
      return "GENERATED";
    case CaseStatus.UNCLAIMED:
      return "UNCLAIMED";
    case CaseStatus.IN_REVIEW:
      return "IN_REVIEW";
    case CaseStatus.RETURNED:
      return "RETURNED";
    case CaseStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CancerType {
  UNSPECIFIED_CANCER_TYPE = 0,
  BREAST = 1,
  LUNG = 2,
  COLON = 3,
  PROSTATE = 4,
  UNRECOGNIZED = -1,
}

export function cancerTypeFromJSON(object: any): CancerType {
  switch (object) {
    case 0:
    case "UNSPECIFIED_CANCER_TYPE":
      return CancerType.UNSPECIFIED_CANCER_TYPE;
    case 1:
    case "BREAST":
      return CancerType.BREAST;
    case 2:
    case "LUNG":
      return CancerType.LUNG;
    case 3:
    case "COLON":
      return CancerType.COLON;
    case 4:
    case "PROSTATE":
      return CancerType.PROSTATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CancerType.UNRECOGNIZED;
  }
}

export function cancerTypeToJSON(object: CancerType): string {
  switch (object) {
    case CancerType.UNSPECIFIED_CANCER_TYPE:
      return "UNSPECIFIED_CANCER_TYPE";
    case CancerType.BREAST:
      return "BREAST";
    case CancerType.LUNG:
      return "LUNG";
    case CancerType.COLON:
      return "COLON";
    case CancerType.PROSTATE:
      return "PROSTATE";
    case CancerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Admin {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  jobRole?: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface Provider {
  id: string;
  emailAddress: string;
  phoneNumber?: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  name?: string | undefined;
  registrationComplete?: boolean | undefined;
  npi?: string | undefined;
  institutionOrPractice?: string | undefined;
  acceptedTermsOfService?: boolean | undefined;
  referralType?: string | undefined;
  referralName?: string | undefined;
}

export interface Reviewer {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  medicalSchool?: string | undefined;
  degree?: string | undefined;
  hospitalOrPractice: string;
  city: string;
  state: string;
  specialty: string;
  mfaEnabled: boolean;
  notificationChannels: { [key: string]: any } | undefined;
  notificationSettings: { [key: string]: any } | undefined;
  isActive: boolean;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

function createBaseAdmin(): Admin {
  return {
    id: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    jobRole: undefined,
    createdAt: undefined,
    updatedAt: undefined,
  };
}

export const Admin: MessageFns<Admin> = {
  encode(message: Admin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.firstName !== "") {
      writer.uint32(18).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(26).string(message.lastName);
    }
    if (message.emailAddress !== "") {
      writer.uint32(34).string(message.emailAddress);
    }
    if (message.phoneNumber !== "") {
      writer.uint32(42).string(message.phoneNumber);
    }
    if (message.jobRole !== undefined) {
      writer.uint32(50).string(message.jobRole);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Admin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdmin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.firstName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.emailAddress = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.jobRole = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Admin {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      firstName: isSet(object.firstName) ? globalThis.String(object.firstName) : "",
      lastName: isSet(object.lastName) ? globalThis.String(object.lastName) : "",
      emailAddress: isSet(object.emailAddress) ? globalThis.String(object.emailAddress) : "",
      phoneNumber: isSet(object.phoneNumber) ? globalThis.String(object.phoneNumber) : "",
      jobRole: isSet(object.jobRole) ? globalThis.String(object.jobRole) : undefined,
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      updatedAt: isSet(object.updatedAt) ? fromJsonTimestamp(object.updatedAt) : undefined,
    };
  },

  toJSON(message: Admin): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.firstName !== "") {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== "") {
      obj.lastName = message.lastName;
    }
    if (message.emailAddress !== "") {
      obj.emailAddress = message.emailAddress;
    }
    if (message.phoneNumber !== "") {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.jobRole !== undefined) {
      obj.jobRole = message.jobRole;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Admin>, I>>(base?: I): Admin {
    return Admin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Admin>, I>>(object: I): Admin {
    const message = createBaseAdmin();
    message.id = object.id ?? "";
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.emailAddress = object.emailAddress ?? "";
    message.phoneNumber = object.phoneNumber ?? "";
    message.jobRole = object.jobRole ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseProvider(): Provider {
  return {
    id: "",
    emailAddress: "",
    phoneNumber: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    name: undefined,
    registrationComplete: undefined,
    npi: undefined,
    institutionOrPractice: undefined,
    acceptedTermsOfService: undefined,
    referralType: undefined,
    referralName: undefined,
  };
}

export const Provider: MessageFns<Provider> = {
  encode(message: Provider, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.emailAddress !== "") {
      writer.uint32(18).string(message.emailAddress);
    }
    if (message.phoneNumber !== undefined) {
      writer.uint32(26).string(message.phoneNumber);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    if (message.name !== undefined) {
      writer.uint32(50).string(message.name);
    }
    if (message.registrationComplete !== undefined) {
      writer.uint32(56).bool(message.registrationComplete);
    }
    if (message.npi !== undefined) {
      writer.uint32(66).string(message.npi);
    }
    if (message.institutionOrPractice !== undefined) {
      writer.uint32(74).string(message.institutionOrPractice);
    }
    if (message.acceptedTermsOfService !== undefined) {
      writer.uint32(80).bool(message.acceptedTermsOfService);
    }
    if (message.referralType !== undefined) {
      writer.uint32(90).string(message.referralType);
    }
    if (message.referralName !== undefined) {
      writer.uint32(98).string(message.referralName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Provider {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.emailAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.registrationComplete = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.npi = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.institutionOrPractice = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.acceptedTermsOfService = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.referralType = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.referralName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Provider {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      emailAddress: isSet(object.emailAddress) ? globalThis.String(object.emailAddress) : "",
      phoneNumber: isSet(object.phoneNumber) ? globalThis.String(object.phoneNumber) : undefined,
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      updatedAt: isSet(object.updatedAt) ? fromJsonTimestamp(object.updatedAt) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      registrationComplete: isSet(object.registrationComplete)
        ? globalThis.Boolean(object.registrationComplete)
        : undefined,
      npi: isSet(object.npi) ? globalThis.String(object.npi) : undefined,
      institutionOrPractice: isSet(object.institutionOrPractice)
        ? globalThis.String(object.institutionOrPractice)
        : undefined,
      acceptedTermsOfService: isSet(object.acceptedTermsOfService)
        ? globalThis.Boolean(object.acceptedTermsOfService)
        : undefined,
      referralType: isSet(object.referralType) ? globalThis.String(object.referralType) : undefined,
      referralName: isSet(object.referralName) ? globalThis.String(object.referralName) : undefined,
    };
  },

  toJSON(message: Provider): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.emailAddress !== "") {
      obj.emailAddress = message.emailAddress;
    }
    if (message.phoneNumber !== undefined) {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.registrationComplete !== undefined) {
      obj.registrationComplete = message.registrationComplete;
    }
    if (message.npi !== undefined) {
      obj.npi = message.npi;
    }
    if (message.institutionOrPractice !== undefined) {
      obj.institutionOrPractice = message.institutionOrPractice;
    }
    if (message.acceptedTermsOfService !== undefined) {
      obj.acceptedTermsOfService = message.acceptedTermsOfService;
    }
    if (message.referralType !== undefined) {
      obj.referralType = message.referralType;
    }
    if (message.referralName !== undefined) {
      obj.referralName = message.referralName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Provider>, I>>(base?: I): Provider {
    return Provider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Provider>, I>>(object: I): Provider {
    const message = createBaseProvider();
    message.id = object.id ?? "";
    message.emailAddress = object.emailAddress ?? "";
    message.phoneNumber = object.phoneNumber ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.name = object.name ?? undefined;
    message.registrationComplete = object.registrationComplete ?? undefined;
    message.npi = object.npi ?? undefined;
    message.institutionOrPractice = object.institutionOrPractice ?? undefined;
    message.acceptedTermsOfService = object.acceptedTermsOfService ?? undefined;
    message.referralType = object.referralType ?? undefined;
    message.referralName = object.referralName ?? undefined;
    return message;
  },
};

function createBaseReviewer(): Reviewer {
  return {
    id: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    medicalSchool: undefined,
    degree: undefined,
    hospitalOrPractice: "",
    city: "",
    state: "",
    specialty: "",
    mfaEnabled: false,
    notificationChannels: undefined,
    notificationSettings: undefined,
    isActive: false,
    createdAt: undefined,
    updatedAt: undefined,
  };
}

export const Reviewer: MessageFns<Reviewer> = {
  encode(message: Reviewer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.firstName !== "") {
      writer.uint32(18).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(26).string(message.lastName);
    }
    if (message.emailAddress !== "") {
      writer.uint32(34).string(message.emailAddress);
    }
    if (message.phoneNumber !== "") {
      writer.uint32(42).string(message.phoneNumber);
    }
    if (message.medicalSchool !== undefined) {
      writer.uint32(50).string(message.medicalSchool);
    }
    if (message.degree !== undefined) {
      writer.uint32(58).string(message.degree);
    }
    if (message.hospitalOrPractice !== "") {
      writer.uint32(66).string(message.hospitalOrPractice);
    }
    if (message.city !== "") {
      writer.uint32(74).string(message.city);
    }
    if (message.state !== "") {
      writer.uint32(82).string(message.state);
    }
    if (message.specialty !== "") {
      writer.uint32(90).string(message.specialty);
    }
    if (message.mfaEnabled !== false) {
      writer.uint32(96).bool(message.mfaEnabled);
    }
    if (message.notificationChannels !== undefined) {
      Struct.encode(Struct.wrap(message.notificationChannels), writer.uint32(106).fork()).join();
    }
    if (message.notificationSettings !== undefined) {
      Struct.encode(Struct.wrap(message.notificationSettings), writer.uint32(114).fork()).join();
    }
    if (message.isActive !== false) {
      writer.uint32(120).bool(message.isActive);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(130).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(138).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Reviewer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.firstName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.emailAddress = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.medicalSchool = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.degree = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.hospitalOrPractice = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.state = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.specialty = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.mfaEnabled = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.notificationChannels = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.notificationSettings = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Reviewer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      firstName: isSet(object.firstName) ? globalThis.String(object.firstName) : "",
      lastName: isSet(object.lastName) ? globalThis.String(object.lastName) : "",
      emailAddress: isSet(object.emailAddress) ? globalThis.String(object.emailAddress) : "",
      phoneNumber: isSet(object.phoneNumber) ? globalThis.String(object.phoneNumber) : "",
      medicalSchool: isSet(object.medicalSchool) ? globalThis.String(object.medicalSchool) : undefined,
      degree: isSet(object.degree) ? globalThis.String(object.degree) : undefined,
      hospitalOrPractice: isSet(object.hospitalOrPractice) ? globalThis.String(object.hospitalOrPractice) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      specialty: isSet(object.specialty) ? globalThis.String(object.specialty) : "",
      mfaEnabled: isSet(object.mfaEnabled) ? globalThis.Boolean(object.mfaEnabled) : false,
      notificationChannels: isObject(object.notificationChannels) ? object.notificationChannels : undefined,
      notificationSettings: isObject(object.notificationSettings) ? object.notificationSettings : undefined,
      isActive: isSet(object.isActive) ? globalThis.Boolean(object.isActive) : false,
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      updatedAt: isSet(object.updatedAt) ? fromJsonTimestamp(object.updatedAt) : undefined,
    };
  },

  toJSON(message: Reviewer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.firstName !== "") {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== "") {
      obj.lastName = message.lastName;
    }
    if (message.emailAddress !== "") {
      obj.emailAddress = message.emailAddress;
    }
    if (message.phoneNumber !== "") {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.medicalSchool !== undefined) {
      obj.medicalSchool = message.medicalSchool;
    }
    if (message.degree !== undefined) {
      obj.degree = message.degree;
    }
    if (message.hospitalOrPractice !== "") {
      obj.hospitalOrPractice = message.hospitalOrPractice;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.specialty !== "") {
      obj.specialty = message.specialty;
    }
    if (message.mfaEnabled !== false) {
      obj.mfaEnabled = message.mfaEnabled;
    }
    if (message.notificationChannels !== undefined) {
      obj.notificationChannels = message.notificationChannels;
    }
    if (message.notificationSettings !== undefined) {
      obj.notificationSettings = message.notificationSettings;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Reviewer>, I>>(base?: I): Reviewer {
    return Reviewer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Reviewer>, I>>(object: I): Reviewer {
    const message = createBaseReviewer();
    message.id = object.id ?? "";
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.emailAddress = object.emailAddress ?? "";
    message.phoneNumber = object.phoneNumber ?? "";
    message.medicalSchool = object.medicalSchool ?? undefined;
    message.degree = object.degree ?? undefined;
    message.hospitalOrPractice = object.hospitalOrPractice ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.specialty = object.specialty ?? "";
    message.mfaEnabled = object.mfaEnabled ?? false;
    message.notificationChannels = object.notificationChannels ?? undefined;
    message.notificationSettings = object.notificationSettings ?? undefined;
    message.isActive = object.isActive ?? false;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
